<template>
    <div>
        <v-card class="elevation-6 mt-5" v-if="!(this.courierData.stationId == null)" width="400">
            <v-card-title>
                <b>
                    Σταθμός Courier
                </b>
            </v-card-title>
            <v-divider></v-divider>
            <v-list dense>
                <v-list-tile>
                    <v-list-tile-content>Courier:</v-list-tile-content>
                    <v-list-tile-content class="align-end">{{this.courierData.courrier.name}}</v-list-tile-content>
                </v-list-tile>
                <v-list-tile>
                    <v-list-tile-content>Περιοχή:</v-list-tile-content>
                    <v-list-tile-content class="align-end">{{this.courierData.description}}</v-list-tile-content>
                </v-list-tile>
                <v-list-tile>
                    <v-list-tile-content>Διεύθυνση:</v-list-tile-content>
                    <v-list-tile-content class="align-end">{{this.courierData.address}}</v-list-tile-content>
                </v-list-tile>
                <v-list-tile>
                    <v-list-tile-content>Τηλέφωνο:</v-list-tile-content>
                    <v-list-tile-content class="align-end">{{this.courierData.phones}}</v-list-tile-content>
                </v-list-tile>
                <v-list-tile>
                    <v-list-tile-content>Fax:</v-list-tile-content>
                    <v-list-tile-content class="align-end">{{this.courierData.fax}}</v-list-tile-content>
                </v-list-tile>
                <v-list-tile>
                    <v-list-tile-content>Ωράριο Λειτουργίας (Καθημερινές):</v-list-tile-content>
                    <v-list-tile-content class="align-end">{{this.courierData.openHoursWeekdays}}</v-list-tile-content>
                </v-list-tile>
                <v-list-tile>
                    <v-list-tile-content>Ωράριο Λειτουργίας (Σάββατο):</v-list-tile-content>
                    <v-list-tile-content class="align-end">{{this.courierData.openHoursSaturday}}</v-list-tile-content>
                </v-list-tile>
                <v-list-tile>
                    <v-list-tile-content>Σημείο στο Χάρτη:</v-list-tile-content>
                    <v-list-tile-content @click="maps" class="align-end pointerCursor">
                        <i><u>Πατήστε Εδώ</u></i>
                    </v-list-tile-content>
                </v-list-tile>
            </v-list>
        </v-card>
        <v-divider></v-divider>
    </div>
</template>

<script>
    export default {
        name: "CourierInfoComponent",
        data() {
            return {
            }
        },
        methods: {
            maps() {
                var url = 'http://www.google.com/maps/place/' + this.courierData.latitude + ',' + this.courierData.longitude;
                window.open(url, '_blank');

            }
        },
        computed: {
            distPointInfo: {
                get() {
                    return this.$store.getters.courierInfo
                }
            },
            courierData: function () {
                return this.$store.getters.courier;
            }

        }
    }
</script>

<style scoped>

</style>